import React from "react";
import "./About.css";

export default function About(): JSX.Element {
  return (
    <main className="page about-page">

      {/* HERO / TITLE */}
      <section className="about-hero">
        <h1>About Us</h1>
        <p>
          A new generation of Australian telecommunications, redefining mobile, NBN, business networks 
          and enterprise-grade solutions backed by unmatched local support and transparency.
        </p>
      </section>

      {/* OUR STORY SECTION */}
      <section className="story-section container">
        <div className="story-text">
          <h2>Our Story</h2>
          <p>
            Jortel was founded to fix the core problem in modern telecommunications: trust.
            We combine the strength of a national network with support that feels personal—
            delivering clarity, reliability and control at scale. 
          </p>
          <p>
This is connectivity engineered for the future of Australia — secure, consistent, and powered by dedicated, end-to-end support. 
          </p>
        </div>

        <div className="story-image">
          <img src="/assets/teamphoto.jpg" alt="Jortel Team" />
        </div>
      </section>

      {/* WHY CHOOSE US */}
<section className="why-section container">
  <h2>Why Choose Us?</h2>

  <div className="why-grid">

    <div className="why-card">
      <h4>Mobile Coverage Transparency</h4>
      <p>Mobile coverage information is published through the Telstra Wholesale Mobile Network coverage map.</p>
    </div>

    <div className="why-card">
      <h4>Enterprise-Grade Quality</h4>
      <p>Network performance engineered for reliability and speed.</p>
    </div>

    <div className="why-card">
      <h4>Australian Support</h4>
      <p>Local experts who understand your environment and your business needs.</p>
    </div>

    <div className="why-card">
      <h4>No Lock-In Contracts</h4>
      <p>Flexible options with no hidden fees — full transparency, always.</p>
    </div>

    <div className="why-card">
      <h4>Generous Data & Rollover</h4>
      <p>Many of our mobile and data plans include rollover and extra allowances.</p>
    </div>

    <div className="why-card">
      <h4>Amazing Service Quality</h4>
      <p>We have a track record of uncompromising service quality and technology solutions engineered for performance.</p>
    </div>

  </div>
</section>


      {/* CTA */}
      <section className="about-cta">
        <h2>Need Help or Want to Learn More?</h2>
        <p>Our Sydney-based team is ready to support you.</p>
        <a href="/contact" className="btn primary">Get in Touch</a>
      </section>

    </main>
  );
}
